import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Portfolio } from "@/components/site/Portfolio";
import { Method } from "@/components/site/Method";
import { Testimonials } from "@/components/site/Testimonials";
import { ContactForm } from "@/components/site/ContactForm";
import { Footer } from "@/components/site/Footer";
import { PressKit } from "@/components/site/PressKit";

const Home = () => (
  <div className="bg-[#090a0f] text-[#eceef2] font-sans antialiased min-h-screen overflow-x-hidden">
    <Nav />
    <Hero />
    <Marquee />
    <Portfolio />
    <Method />
    <Testimonials />
    <ContactForm />
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/press" element={<PressKit />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
